import {openDB, idb} from 'idb';

import JavascriptHelpers from '../components/lib/Javascript/JavascriptHelpers';
import ServiceDataResponse from '../models/ServiceDataResponse';
import ServiceResponse from '../models/ServiceResponse';


// indexes e.g. {field: "offlineId", name: "offlineId", unique: true}
export default class IDbService
{
    constructor(objectStoreId, dbName, indexes)
    {
        this.defaultObjectStore = objectStoreId//"observation";
        this.dbName = dbName;
        this.idb = {
            obsDb: openDB(this.dbName, 1,{  //"obsDb", 1,{
                upgrade: (db, oldVersion, newVersion, transaction) => {
                    switch(oldVersion)
                    {
                        case 0:
                            
                             const store = db.createObjectStore(this.defaultObjectStore) //'observation');
                             if (indexes)
                             {
                                indexes.forEach((i) => {
                                    store.createIndex(i.field, i.name, {unique: i.unique} )
                                })
                             }
                             //store.createIndex("offlineId", "offlineId", {unique: true});
                            // fall through so that we can upgrade.
                        case 1:
                            break;
                        default:
                            console.log("unknown db version");
                    }

                }
            })
        };
    }

    /*
    async updateQaObservationPendingToVoid(gcid, offlineId){
       var obs = await this.fetchObservation(gcid, offlineId); 
       console.group("Local Storage Observation: ");
       console.log(obs);
       console.groupEnd();

       obs.Offline.uploadStatus = 'void-pending';

       await this.deleteObservation(offlineId);
       (await this.idb.obsDb).add('observation', obs, offlineId); // add the complete observation back, including offline info
    }
    */

    static toLocalObservation(gcid, obs, offlineId)
    {
        let hasImages = ((obs.data.Raw.userimages) && (obs.data.Raw.userimages.length>0));
        obs.data.hasImages = hasImages;
        let hasDocs = ((obs.data.Raw.userdocs) && (obs.data.Raw.userdocs.length>0));
        obs.data.hasDocs = hasDocs;
        var localObservation = {
            "Gcid": gcid, "ObservedBy": obs.data.UnderInspection.Inspector, "ObservationLocation": obs.data.UnderInspection.Location, "ObservationDate": obs.data.UnderInspection.InspectionDate,
            "ObservationType": "QADOCKINSPECTION", "RecordedDate": obs.data.UnderInspection.InspectionDate, "SchemaId": obs.data.schema.id, "SchemaVersion" : obs.data.schema.schemaVersion,
            "ObservationHash": null, "ScoreReason": obs.score.Score.ScoreReason,
            "ScoreGrade": obs.score.Score.Grade.Weighted, "ScoreGradeInt": 0,
            "HasImages": hasImages,
            "HasDocs": hasDocs,
            "ObservationSnapshot" : JSON.stringify(obs),
            "offlineId": offlineId,
            "Offline": {id: offlineId, isUploaded: false, uploadStatus: 'pending', lastStatusUpdate: JavascriptHelpers.isoNow()}
            //offlineId: newOfflineId, observation: observation, isUploaded: false, uploadStatus: 'awaiting', lastStatusDate: moment().format()
        };
        return localObservation;
    }

    async addObservation(gcid, obs, offlineId)
    {
        try
        {
            var localObservation = IDbService.toLocalObservation(gcid, obs, offlineId);
            (await this.idb.obsDb).add('observation', localObservation, offlineId);
            return ServiceResponse.toServiceResponse("Local Observation added", false);
        }
        catch(e)
        {
            msgs = e.messages;
            msgs.unshift("Problem adding Local Observation.");
            return ServiceResponse.toServiceResponse(msgs, true);
        }

    }

    async fetchObservation(gcid, offlineId)
    {
        try
        {
            var resultData = await (await this.idb.obsDb).get("observation", offlineId);
            return ServiceDataResponse.toServiceDataResponse(resultData, "Observation " + offlineId + " fetched.", false);
        }
        catch(e)
        {
            msgs = e.messages;
            msgs.unshift("Problem fetching Local Observation by id " + offlineId + ". ");
            return ServiceDataResponse.toServiceDataResponse(null, msgs, true);
        }
    }

    async fetchAllObservations()
    {
        try
        {
            var resultData = await (await this.idb.obsDb).getAll("observation");
            var result = resultData.map(offlineRec =>{
                console.log("offlineRec:");
                console.log(offlineRec);
                var res = JSON.parse(offlineRec.ObservationSnapshot);
                // add offline status fields
                res.identifiers = {id: offlineRec.Offline.id, gcid: offlineRec.Gcid, status: offlineRec.Offline.uploadStatus, statusReason: ""} ;
                return res;
            }) ;
            return ServiceDataResponse.toServiceDataResponse(result, "All Local Observations Fetched Successfully.", false)
        } 
        catch(e)
        {
            msgs = e.messages;
            msgs.unshift("Problem fetching All Local Observations. ");
            return ServiceDataResponse.toServiceDataResponse(null, msgs, true);
        }

    }


    async deleteObservation(offlineId)
    {
        try
        {
            var result = await (await this.idb.obsDb).delete("observation", offlineId);   
            return ServiceResponse.toServiceResponse("Local observation " + offlineId + " removed successfully.", false); 
        }
        catch(e)
        {
            msgs = e.messages;
            msgs.unshift("Problem removing Local Observation " + offlineId + ". ", true);
            return ServiceDataResponse.toServiceDataResponse(null, msgs, true);
        }

    }



}



